import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="defer-paint w-full bg-ivory py-10 sm:py-12" aria-labelledby="faq-heading" data-id="element-72" data-mp="1bl23p9e8x8f0">
      <div className="mx-auto max-w-3xl px-6" data-id="element-73" data-mp="1gj3llqzxr1ow">
        <div className="text-center" data-id="element-74" data-mp="1gjvkbaotxfje">
          <p className="eyebrow text-terracotta-deep" data-id="element-75" data-mp="249g4fwwpyiu9">Before you decide</p>
          <h2 id="faq-heading" className="mt-5 font-display text-[2rem] leading-[1.12] text-ink sm:text-4xl" data-id="element-76" data-mp="24ban14kipyv6">
            Frequently asked questions
          </h2>
        </div>

        <ul className="mt-12 space-y-2.5" data-id="element-77" data-mp="1uiv68akyjgbv">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className={`rounded-3xl border bg-shell transition-colors duration-150 ease-out ${isOpen ? 'border-terracotta/45' : 'border-line'}`} data-id="element-78" data-mp="2n8255aobq7xn" data-mpi={index}>
                <h3 data-id="element-79" data-mp="2s03eanq73ijg">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 rounded-3xl px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-terracotta" data-id="element-80" data-mp="2s0lfzzvmmoyr">
                    <span className="font-display text-lg leading-snug text-ink sm:text-xl" data-id="element-81" data-mp="19tlkw6b473jj">
                      {faq.question}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out ${isOpen ? 'bg-terracotta text-ivory' : 'bg-terracotta-light text-terracotta-deep'}`} aria-hidden="true" data-id="element-82" data-mp="1jkgi25pwfnjr">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-83" data-mp="1sled3yid0kq7" />
                    </span>
                  </button>
                </h3>

                <div id={`faq-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-84" data-mp="3udsrinlp371v">
                  <div className="overflow-hidden" data-id="element-85" data-mp="238pu2nxjuai3">
                    <p className="px-6 pb-6 font-sans text-[0.93rem] leading-relaxed text-stone" data-id="element-86" data-mp="286repdamihvo">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}